module.exports = __webpack_public_path__ + "static/img/_N2E0868-1080p.a5394cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio3/_N2E0868-1080p.jpg
// module id = ZzBd
// module chunks = 0